import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '@nx-ratenow/core/data-access-layaout';
import { LocalService } from '@nx-ratenow/core/data-access-local-storage';
import { NavigationServiceAdminWeb } from '@nx-ratenow/core/data-access-navigation';
import { checkRouterChildsData } from '@nx-ratenow/shared/utils';
import { delay, filter, map, startWith } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'nx-ratenow-ui-custom-layout',
  templateUrl: './ui-custom-layout.component.html',
  styleUrls: ['./ui-custom-layout.component.scss']
})
export class UiCustomLayoutComponent {
  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$.pipe(startWith(null), delay(0));

  isFooterVisible$ = this.layoutService.showFooter$.pipe(startWith(null), delay(0));

  isDesktop$ = this.layoutService.isDesktop$;

  toolbarShadowEnabled$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, (data: any) => data.toolbarShadowEnabled))
  );

  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private route: ActivatedRoute,
    private localService: LocalService,
    private navigationServiceAdminWeb: NavigationServiceAdminWeb,
    private translateService: TranslateService
  ) {
    this.route.data.subscribe((data) => {
      const userLoggedInfo = data['userLoggedInfo'];
      if (!userLoggedInfo) return;

      this.localService.saveData('user', JSON.stringify(userLoggedInfo));
      this.navigationServiceAdminWeb.loadNavigation();

      const storedLang = localStorage.getItem('LANG');
      const lang = storedLang ?? userLoggedInfo.personLanguage;
      if (lang) {
        this.translateService.use(lang);
      }
    });
  }
}
